import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { APP_CONFIG, BaseAppConfig } from '@avenir-client-web/models';
import { Observable } from 'rxjs';

/**
 * Prefixes all requests not starting with `http[s]` with `environment.serverUrl`.
 */
@Injectable()
export class ApiPrefixInterceptor implements HttpInterceptor {
  constructor(@Inject(APP_CONFIG) private readonly config: BaseAppConfig) {}

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    if (!/^(http|https):/i.test(request.url)) {
      let subPath = '';

      if (
        ['metadata/related-contents', 'ticket', 'chats'].some(item =>
          request.url.includes(item)
        )
      )
        subPath = '/ticket';
      if (request.url.includes('notification')) subPath = '/notification';

      request = request.clone({
        url: `${this.config.serverUrl}${subPath}/api/${request.url}`,
      });
    }

    return next.handle(request);
  }
}
